export default function Loading({background}) {
    return <div
        id="vz_loading"
        className="d-flex justify-content-center align-items-center text-center h-100"
        style={{
            background: background
        }}
    >
        <p>Loading...</p>
    </div>
}